import {AfterViewInit, ChangeDetectorRef, Component, Input, NgZone, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationStart, Router} from "@angular/router";
import {environment} from "../../environments/environment";
import {ItemService} from "./item.service";
import {MatSelectModule} from "@angular/material/select";
import {MatFormFieldModule} from "@angular/material/form-field";
import {BreadcrumbService} from "xng-breadcrumb";
import {filter} from "rxjs";
import {Globals} from "../globals";
import {AllService} from "../all/all.service";

@Component({
  standalone: false,
  selector: 'app-item',
  templateUrl: './items.component.html',
  styleUrls: ['./items.component.css'],
  imports: [MatFormFieldModule, MatSelectModule]
})
export class ItemsComponent implements OnInit{
  @Input () url: any;
  @Input () itemsShop: any;
  @Input () imageSrc: any;
  @Input () counties: any;
  itemsUrl: any;
  itemsShopList = [];
  urlList;
  environment: any;
  itemsShopCopy: any;
  breadcrumb: any = [];
  breadcrumbs: any;
  finalBreadcrumb: any;
  in_itemsShop: any;
  home: string = 'home';
  category: string = 'category';
  subcategory: string = 'subcategory';
  selectedLocation = 'All';
  selectedCategory = 'All';
  selectedSubcategory = 'All';
  categories = [];
  subcategories = [];
  urlName: string = '';
  subUrlName: string = '';

  constructor(private activatedRoute: ActivatedRoute,
              private router: Router,
              private shopService: ItemService,
              private allService: AllService,
              private breadcrumbService: BreadcrumbService,
              public globals: Globals) {
    environment.then(environment => {
      this.url = environment["backendURL"];
      this.imageSrc = environment["images"];
    });

/*    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };*/
    // this.url = 'localhost:8086';
    // console.log('tester router', this.url);
    this.itemsShop = this.router.getCurrentNavigation().extras.state.search_items;
    this.itemsShop.forEach(
      item => {
        this.sortBreadcrumb(item);
        this.sortItemImages(item, this.url, this.imageSrc);
        this.checkSubcategoryNameForUrl(item);
      });
  }

  ngOnInit(): void {
    this.breadcrumbService.set('@Items', 'Items');

    let urls = this.router.url.split('/').filter(element => element);

    let endpoint = '/sport';
    if (urls.length == 3) {
      this.urlName = urls[1];
      this.subUrlName = urls[0];
      endpoint = urls[1].replace('all-', '');
      endpoint = endpoint.replace('-', ' ');
    }
    // console.log(urls, this.urlName, this.subUrlName);
    if (urls[1].includes('all-')) {
      this.allService.getAllByItem(this.url + '/' + endpoint)
        .subscribe(response => {
          this.itemsShop = response;
          this.itemsShop.forEach(
            item => {
              this.sortItemImages(item, this.url, this.imageSrc);
              if (this.globals.location === item.locationId.name || this.globals.location === 'All') {
                this.checkSubcategoryNameForUrl(item);
                this.itemsShopList.push(item)
              }
            });
          this.itemsShopList.sort((a, b) => a.subCategoryId.name.localeCompare(b.subCategoryId.name));
        });

    } else {
      this.allService.getSearchCategories(this.url, urls[0], this.getSubcategoryUrl(endpoint))
        .subscribe(response => {
          this.itemsShop = response;
          this.itemsShop.forEach(
            item => {
              this.sortItemImages(item, this.url, this.imageSrc);
              if (this.globals.location === item.locationId.name || this.globals.location === 'All') {
                this.checkSubcategoryNameForUrl(item);
                this.itemsShopList.push(item)
              }
            });
          this.itemsShopList.sort((a, b) => a.subCategoryId.name.localeCompare(b.subCategoryId.name));
        });
    }
    this.sortSideBar();
    this.allService.getCounties(this.url, '/counties')
      .subscribe(response => {
        this.counties = response;
        this.counties.push({locationId: 33, name: 'All', province: 'All'});
        this.counties.sort((a, b) => a.name.localeCompare(b.name));
      });
  }

  private sortSideBar() {
    this.urlList = [];
    this.allService.getAllByItem(this.url + '/' + this.subUrlName)
      .subscribe(response => {
        this.itemsUrl = response;
        this.itemsUrl.sort((a, b) => a.subCategoryId.name.localeCompare(b.subCategoryId.name));
        for (let j = 0; j < this.itemsUrl.length; j++) {
          let i;
          let item = this.itemsUrl[j];
          if (j === 0) {
            let sub = 'all-' + item;
            this.urlList.push({
              category: this.getCategory(item),
              subcategory: sub,
              display: sub.replace('-', ' ')
            });
            // console.log('one', this.getAllSubcategory(this.getCategory(item)))
          }
          else {
            let sub = this.getSubcategory(item);
            i = {
              category: this.getCategory(item),
              subcategory: sub,
              display: sub.replace('-', ' ')
            };
            // console.log('two', i.subcategory);

            if (this.urlList.findIndex((it) => it.subcategory === i.subcategory) < 0) {
              this.urlList.push(i);
            }
          }
        }
        if(this.urlList.length > 1) {
          this.urlList.sort((a, b) => a.subcategory.localeCompare(b.subcategory));
        }
      });
  }

  private getCategory(item) {
    if (item.subCategoryId.categoryByCategoryId.name === 'house & diy') {
      return 'household';
    } else if (item.subCategoryId.categoryByCategoryId.name.includes(' & ')) {
      return item.subCategoryId.categoryByCategoryId.name.replace(' & ', '-and-');
    } else {
      return item.subCategoryId.categoryByCategoryId.name;
    }
  }

  private getSubcategory(item: any) {
    if (item.subCategoryId.name.includes(' & ')) {
      return item.subCategoryId.name.replace(' ', '-');

    } else if (item.subCategoryId.name.includes(' ')) {
      return item.subCategoryId.name.replace(' ', '-');

    } else {
      return item.subCategoryId.name;
    }
  }

  private checkSubcategoryNameForUrl(item: any) {
    if(item.subCategoryId.categoryByCategoryId.name.includes(' & ')){
      item.subCategoryId.categoryByCategoryId.name.replace(' & ', '-and-');
    }

    if (item.subCategoryId.name.includes(' ')) {
      item.subCategoryId.name = item.subCategoryId.name.replace(' ', '-');
    }
  }

  private getSubcategoryUrl(endpoint: string) {
    if(endpoint === 'furniture interior') {
      return 'furniture & interior';
    }
    return endpoint;
  }

  getSearchItem(in_itemsShop: any) {
    // console.log('in_item', in_itemsShop);
    this.categories = [];
    this.subcategories = [];
    if(this.itemsShop == null) {
      this.shopService.getSearchItem(this.url, in_itemsShop)
        .subscribe(response => {
              this.itemsShopCopy = response;
          this.itemsShopCopy.forEach(
            item => {
              // this.sortBreadcrumb(item);
              this.sortItemImages(item, this.url, 'assets/');
              this.checkSubcategoryNameForUrl(item);


            });
          // console.log('this.itemsShop', this.itemsShopCopy);


          /*this.shopService.getCounties(this.url, '/counties')
            .subscribe(response => {
              this.counties = response;
            });*/
          // console.log(this.breadcrumb);
         });
    } else {
      // this.itemsShop = this.itemsShopOne;

    }
  }

 /* onSelectedCategory(value: any): void {
    console.log(value.value);
    // this.itemsShop = [];
    this.subcategories = [];
    this.itemsShopCopy.forEach(
      item => {
        if (item.subCategoryId.categoryByCategoryId.name === value.value) {
          this.itemsShop.push(item);
          if (!this.subcategories.includes(item.subCategoryId.name)) {
            this.subcategories.push(item.subCategoryId.name);
          }
        }
      });
  }*/

  /*onSelectedSubcategory(value: any): void {
    console.log(value.value);
    this.itemsShop = [];
    // this.subcategories = [];
    let category = '';
    this.itemsShopCopy.forEach(
      item => {
        if (item.subCategoryId.name === value.value) {
          this.itemsShop.push(item);
        }

        /!*if (!this.subcategories.includes(item.subCategoryId.name) &&
          item.subCategoryId.categoryByCategoryId.name == category) {
          this.subcategories.push(item.subCategoryId.name);
        }*!/
      });
  }*/

  private sortItemImages(item, url, imgStr) {
    let photosTemp = item.photo.split(";");
    if (photosTemp) {
      item.photo = imgStr + photosTemp[0];
    } else {
      item.photo = imgStr + item.photo
    }
  }

  private sortBreadcrumb(item) {
    this.breadcrumb = [];
    this.finalBreadcrumb = [];
    let crumb = '';
    let crumbs = {};
    let crumbReserve = {
      home: 'home',
      category: 'item-search',
      isCategory: false,
      subcategory: '',
      isSubcategory: false,
      item: ''
    };
    let crumbItem = '';
    let isCrumb = true;
    if (this.breadcrumb.length > 0 && item.name.length < crumbItem.length) {
      isCrumb = false;
      crumbReserve = {
        home: 'home',
        category: 'all - item search',
        isCategory: false,
        subcategory: null,
        isSubcategory: false,
        item: ''
      };
      crumbItem = item.name;
    }

    crumb = 'home,' + item.subCategoryId.categoryByCategoryId.name + ',' + item.subCategoryId.name + ',' + item.name;
    crumbs = {
      home: 'home',
      category: item.isCategory ? item.subCategoryId.categoryByCategoryId.name : '',
      isCategory: item.isCategory,
      subcategory: item.isSubcategory ? item.subCategoryId.name : '',
      isSubcategory: item.isSubcategory,
      item: item.isCategorySubcategory ? item.name : ''
    };
    if (this.breadcrumb.length == 0) {
      this.breadcrumb.push(crumbs);
      crumbItem = item.name;
    }
    if (this.breadcrumb.size > 0 || !this.breadcrumb.includes(crumbs) && item.isItemSearch) {
      this.breadcrumb = [];
      this.breadcrumb.push(crumbReserve);
    }
  }

  /*changeUrl(url: string, isSearchUrl: string) {
    console.log(url, isSearchUrl);
    let data = {};
    if(isSearchUrl === 'category') {
      data = {
        item: '',
        location: this.itemsShop[0].locationIn,
        category: url,
        subcategory: null,
        isCategorySubcategory: false

      };
    } else if(isSearchUrl === 'subcategory') {
      data = {
        item: '',
        location: this.itemsShop[0].locationIn,
        category: this.itemsShop[0].subCategoryId.categoryByCategoryId.name,
        subcategory: url,
        isCategorySubcategory: false
      };
    }
    this.router.navigateByUrl('/item', {skipLocationChange: true}).then(() => {
      this.router.navigate(['item', {search_items: JSON.stringify(data)}]);
    });
  }*/

/*  redirectShop(event: any) {
    console.log(event);
    let data = '' + event.itemId + '_';
    let obj = {p1: data};
    console.log(obj);
    this.router.navigate(['product-single', {search_item: JSON.stringify(obj)}]);
  }

  showAsList() {
    this.isPanel = false;
    this.isList = true;
  }

  showAsPanels() {
    this.isList = false;
    this.isPanel = true;
  }*/

}
